import React from "react";
import "../index.css";
import qr from "../img/qr.png";

export default function Card() {
    return (
        <>
            {/* QR в левом верхнем углу, но больше */}
            <a href="/" className="qr-corner" aria-label="Back" title="Back">
                <img src={qr} alt="QR code" className="qr-corner-img"/>
            </a>
            <div className="contact-box">
                <div>Email: kernundsinn@gmail.com</div>
                <div>Nummer: +49 157 50640682</div>
            </div>

            <div className="card-hero">
                {/* Instagram слева у края градиента */}
                <a
                    className="social-pill ig-pill"
                    href="https://instagram.com/michail_kern"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Instagram
                </a>

                <a
                    className="social-pill fb-pill"
                    href="https://www.facebook.com/share/16PpiGPKXm/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Facebook
                </a>

                <a
                    className="social-pill tg-pill"
                    href="https://t.me/Michael_Kern"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Telegram
                </a>
            </div>

            {/* Остальная часть страницы может быть пустой/белой */}
            <div style={{height: "60vh"}}/>
        </>
    );
}
